import React from 'react';

import { Config } from '@modernanimal/common';
import { initializeSentry } from '@modernanimal/common/src/sentry';
import * as Sentry from '@sentry/react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { PostHogProvider } from 'posthog-js/react';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';
import {
    createBrowserRouter, RouterProvider
} from 'react-router-dom';

import BingTracking from './BingTracking';
import ExistingAccount from './onboarding/ExistingAccount';
import OnboardingEntry from './OnboardingEntry';

if (process.env.REACT_APP_LOCAL_SERVER) {
    Config.ApiRoot = 'http://localhost:8000/';
}

initializeSentry(
    'https://f1d794c7fcd9def5706200cd8a690131@o230512.ingest.sentry.io/4505706342645760',
    { skipInitialUser: true }
);

const getBasename = () => {
    if (window.location.hostname === 'localhost' || window.location.host.includes('3000')) {
        return '';
    }
    return '/booking';
};

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

const router = sentryCreateBrowserRouter([{
    path: '/*',
    element: <OnboardingEntry />,
    children: [{
        path: 'download-app',
        element: <ExistingAccount />,
    }]
}], {
    basename: getBasename()
});

const {
    REACT_APP_GOOGLE_TAG_MANAGER_ID = '',
    REACT_APP_GOOGLE_TAG_MANAGER_ENVIRONMENT_AUTH_STRING = '',
    REACT_APP_GOOGLE_TAG_MANAGER_ENVIRONMENT_PREVIEW_NAME = ''
} = process.env;

TagManager.initialize({
    gtmId: REACT_APP_GOOGLE_TAG_MANAGER_ID,
    auth: REACT_APP_GOOGLE_TAG_MANAGER_ENVIRONMENT_AUTH_STRING,
    preview: REACT_APP_GOOGLE_TAG_MANAGER_ENVIRONMENT_PREVIEW_NAME,
});

const postHogOptions = {
    api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
    opt_in_site_apps: true,
};

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <PostHogProvider
            options={postHogOptions}
            apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
        >
            <RouterProvider router={router} />
            <BingTracking />
        </PostHogProvider>
    </React.StrictMode>
);
